import * as leadUtils from '../../../../services/utils/leads';

const getLeadUser = state => state.lead.infoLead.lead;
const getLeadPhones = state => state.lead.infoLead.phones;
const getLeadStatuses = state => state.lead.infoLead.statuses;
const getLeadWarning = state => state.lead.infoLead.feedback_warning;

const getPostingData = state => state.lead.infoLead.posting;

const getLeadId = state => state.lead.infoLead.id;

const getContacPublisherUserid = state => state.lead.infoLead.contacPublisherUserid;

const getLeadStatus = state => state.lead.infoLead.contactResponseStatus;

const getLoading = state => state.lead.infoLead.loading;

const getEmailVerification = state => state.lead.infoLead.emailVerification;

const getPhoneVerification = state => state.lead.infoLead.phoneVerification;

const getSnackBar = state => state.lead.infoLead.snackBar;

const getSnackBarLeadDetail = state => state.lead.infoLead.snackBarLeadDetail;

const getLoadingStatus = state => state.lead.infoLead.loadingStatus;

const isRead = state => leadUtils.isRead(state.lead.infoLead.statuses);

const isFavorite = state => leadUtils.isFavorite(state.lead.infoLead.statuses);

const isDiscarded = state => leadUtils.isDiscarded(state.lead.infoLead.statuses);

const isSpam = state => leadUtils.isSpam(state.lead.infoLead.statuses);

const getSmartLead = state => state.lead.infoLead.smartLead;

const getScoringLead = state => state.lead.infoLead.scoreLead;

const getRenterProfile = state => state.lead.infoLead.renterProfile;

const getRelated = state => state.lead.infoLead.related;
const getAskFeedback = state => state.lead.infoLead.ask_feedback;
const getShowAskFeedback = state => state.lead.infoLead.show_ask_feedback;
const getFeedbackUrl = state => state.lead.infoLead.feedbackLink;

const getCustomAnswers = state => state.lead.infoLead.customAnswers;

const getMessageAttachment = state => state.lead.infoLead.MessageAttachment;

const getCustomAnswerStatus = state => state.lead.infoLead.customAnswerStatus;
const getDocument = state => state.lead.infoLead.document;
const getClickPhone = state => state.lead.infoLead.phoneSelected;
const getLoadingFeedback = state => state.lead.infoLead.loadingFeedback;
const getEtiquetas = state => state.lead.infoLead.leadStatus;
const getEstatusSendMail = state => state.lead.infoLead.emailStatus;

export {
  getSnackBarLeadDetail,
  getSmartLead,
  getScoringLead,
  getRelated,
  isRead,
  isFavorite,
  isDiscarded,
  isSpam,
  getLoadingStatus,
  getSnackBar,
  getEmailVerification,
  getPhoneVerification,
  getLeadUser,
  getLeadStatuses,
  getPostingData,
  getLeadId,
  getLoading,
  getCustomAnswers,
  getRenterProfile,
  getCustomAnswerStatus,
  getMessageAttachment,
  getLeadPhones,
  getDocument,
  getClickPhone,
  getAskFeedback,
  getShowAskFeedback,
  getFeedbackUrl,
  getLoadingFeedback,
  getLeadStatus,
  getContacPublisherUserid,
  getEtiquetas,
  getEstatusSendMail,
  getLeadWarning
};
